import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppConfigService } from 'src/app/services/app-config/app-config.service';

@Component({
  selector: 'app-trial-warning-dialog',
  templateUrl: './trial-warning-dialog.component.html',
  styleUrls: ['./trial-warning-dialog.component.scss']
})
export class TrialWarningDialogComponent {
  public websiteUrl: string;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { statusId: number; trialDaysLeft: number },
    private dialogRef: MatDialogRef<TrialWarningDialogComponent>,
    private appConfig: AppConfigService
  ) {
    this.websiteUrl = this.appConfig.websiteUrl;
  }

  get title(): string {
    if (this.data.statusId === 1 && this.data.trialDaysLeft > 1)
      return 'Seu teste grátis está ativo!';
    else if (this.data.statusId === 1 && this.data.trialDaysLeft === 1)
      return 'Seu teste grátis está prestes a expirar!';
    else
      return 'Seu teste expirou, faça o upgrade para continuar!';
  }

  get description(): string {
    if (this.data.statusId === 1 && this.data.trialDaysLeft > 1) {
      return `Durante seu período de Teste, você tem acesso aos nossos recursos para facilitar a gestão do seu negócio.
              <b>Dica:</b> Explore todas as funcionalidades e veja como podemos ajudar no seu dia a dia!
              Caso queira garantir o uso contínuo do sistema sem preocupações, conheça nossos planos e escolha o ideal para você.`;
    } 
    else if (this.data.statusId === 1 && this.data.trialDaysLeft === 1) {
      return `Seu período de Teste está quase no fim!
              Não perca a oportunidade de continuar gerenciando seu negócio com eficiência.
              Ao adquirir um plano, você mantém o acesso a todas as funcionalidades e suporte especializado.
              <b>Garanta a continuidade agora mesmo e evite interrupções!</b>`;
    } 
    else {
      return `Seu período de Teste chegou ao fim. Mas não se preocupe!
              Você pode continuar aproveitando todos os benefícios adquirindo um plano agora mesmo.
              <b>Mantenha o controle total do seu negócio sem interrupções!</b>`;
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
